var map = {
	"./skill-01.jpg": 67662,
	"./skill-02.jpg": 47929,
	"./skill-03.jpg": 77404,
	"./skill-04.jpg": 78951,
	"./skills-01.jpg": 58941,
	"./skills-01.svg": 77515,
	"./skills-02.jpg": 23634,
	"./skills-02.svg": 22328,
	"./skills-03.jpg": 15,
	"./skills-03.svg": 57193,
	"./skills-04.svg": 70950
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 61475;